import { useAui, useAuiState } from '@assistant-ui/react';

import { Badge } from '@playbooks/ui/components/badge';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';

import { parseAgentUrls } from 'utils/agent-urls';

const ComposerUrlReferences = () => {
	const aui = useAui();
	const text = useAuiState((state: any) => state.composer.text || '');
	const urls = parseAgentUrls(text);
	if (!urls.length) return null;
	const remove = reference =>
		aui
			.composer()
			.setText(
				`${text.slice(0, reference.position)}${text.slice(reference.position + reference.token.length)}`.replace(
					/ {2,}/g,
					' ',
				),
			);
	return (
		<div className='flex flex-wrap gap-1 px-3 pt-2'>
			{urls.map(reference => {
				const url = new URL(reference.url);
				return (
					<Badge key={reference.url} variant='secondary' title={reference.url} className='gap-1'>
						<Icon type='far' icon='link' aria-hidden />
						<span className='max-w-48 truncate'>
							{url.hostname}
							{url.pathname === '/' ? '' : url.pathname}
						</span>
						<Button
							size='icon-xs'
							variant='ghost'
							aria-label={`Remove ${reference.url}`}
							onClick={() => remove(reference)}>
							<Icon type='far' icon='xmark' aria-hidden />
						</Button>
					</Badge>
				);
			})}
		</div>
	);
};

export { ComposerUrlReferences };
